import React from 'react';
import { IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonPage, IonRow, IonSpinner, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import './Settings.css';
import { withRouter } from 'react-router';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { deleteRequest, getJson, postJson } from '../fetchFunctions';
import { Storage } from '@capacitor/storage';
import { error, success } from '../components/ToastController';
import { alertDelete } from '../components/DialogController';
import QRCode from "react-qr-code";
import { logOutOutline } from 'ionicons/icons';
import { Friends }  from './Friends';
import {Clipboard} from '@ionic-native/clipboard'


class Settings extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			loading: true,
			privateKey: "",
			personData: null,
			nameInput: "",
			saveEnabled: false,
			saving: false,
			deleting: false
		}
	}

	ionViewWillEnter() {
		Friends.stopRefreshing();
		this.setState({loading: true});

		//TODO make fetch request here to get the person data

        Storage.get({key: 'clientId'}).then(clientId => {
            if(clientId.value)
            {
				getJson("users/get/private/" + clientId.value).then(response => {
					if(response.ok)
					{
						response.json().then((user: any) => {
							this.setState({privateKey: clientId.value, personData: user, nameInput: user.name, loading: false, deleting: false, saving: false, saveEnabled: false});
						})
					}
					else if(response.status > 0) 
					{
						response.text().then((text: any) => console.error("[settings get user] error code " + response.status + ", msg: " + text));
					}
				}).catch(ex => console.error(ex));
            }
			else {
				//Do error toast or something like that
				error("Failed to load client id");
			}
        })

	}

	validateSaveEnabled = () => {
		this.setState({saveEnabled: this.state.nameInput !== this.state.personData.name});
	}

	saveName = () => {
		this.setState({saving: true});

		postJson("users/name/change", {
			privateKey: this.state.privateKey,
			name: this.state.nameInput
		}).then(response => {
			if(response.ok) {
				response.json().then((user: any) => {
					this.setState({saving: false, personData: user, saveEnabled: false});
				})
			}
			else if(response.status > 0) {
				response.text().then((text: any) => console.error("[settings change name] error code " + response.status + ", msg: " + text));
			}
		})
		//TODO fetch request to change name here
	}

	deleteAccount = (e: any) => {

		alertDelete("Sletning af bruger", "Er du sikker på at du vil slette din bruger?", () => {
			this.setState({deleting: true});
			deleteRequest("users/delete/" + this.state.privateKey).then(response => {
				if(response.ok) {
					success("Din bruger er blevet slettet!");
					Storage.remove({key: 'clientId'}).then(() => {
						Storage.remove({key: 'publicKey'}).then(() => {
							this.props.history.push("/");
						})
					}) 
				}
				else if(response.status > 0) {
					response.text().then((text: any) => console.error("[settings delete user] error code " + response.status + ", msg: " + text));
				}
			})
		})
	}

	onPrivateIdTouched = (e: any) => {
		Clipboard.copy(this.state.privateKey);
		success("Privat ID kopieret");
		navigator.clipboard.writeText(this.state.privateKey);

	}

	render() {
		return (
			<IonPage>
				<IonHeader>
					<IonToolbar>
						<IonTitle>Indstillinger</IonTitle>
					</IonToolbar>
				</IonHeader>
				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonTitle size="large">Indstillinger</IonTitle>
						</IonToolbar>
					</IonHeader>
					{this.state.loading ? 
						<div style={{display: "flex", height: "100%", justifyContent: "center", alignItems: "center"}}>
							<IonSpinner style={{width: "10vw", height: "10vw"}} color="tertiary" name="lines-sharp" />
						</div>	
					: 
					<div style={{marginTop: "10px", marginLeft: "16px"}}>
						<div>
							<IonGrid>
								<IonRow>
									<IonCol>
										<h4>Navn</h4>
									</IonCol>
								</IonRow>
								<IonRow>
									<IonCol size="7">
										<InputText value={this.state.nameInput} style={{width: "100%"}} placeholder="Navn" onChange={(e: any) => this.setState({nameInput: e.target.value}, this.validateSaveEnabled)} />
									</IonCol>
									<IonCol size="5" style={{display: "flex", alignItems: "center"}}>
										<Button style={{marginLeft: "10px", width: "100%"}} className="p-button-primary" disabled={this.state.deleting || !this.state.saveEnabled} loading={this.state.saving} label="Gem" onClick={this.saveName} iconPos="left" icon="pi pi-save" />
									</IonCol>
								</IonRow>
							</IonGrid>
						</div>
						<p style={{color: "#777", fontFamily: "Consolas, Courier New"}}>Offentlig ID: {this.state.personData.publicKey}</p>
						<p onClick={this.onPrivateIdTouched} style={{color: "#777", fontFamily: "Consolas, Courier New"}}>Privat ID: {this.state.privateKey}</p>

						<div style={{textAlign: "center", color: "#777", position: "absolute", left: "50%", transform: "translateX(-50%)", width: "80%"}}>
							Vis denne kode til dine venner så de hurtigt og nemt kan tilføje dig som ven
						</div>
						<div style={{display: "flex", justifyContent: "center", marginTop: "70px"}}>
							<QRCode value={this.state.personData.publicKey}></QRCode>
						</div>

						<div style={{display: "flex", justifyContent: "center", marginTop: "24px", marginBottom: "24px"}}>
							<Button onClick={() => this.props.history.push("/?dontAutoLogin=true")} label="Log ud" className="p-button-raised p-button-help p-button-text">
								<IonIcon icon={logOutOutline} style={{marginLeft: "20px", fontSize: "24px"}} />
							</Button>
							<Button style={{marginLeft: "20px"}} className="p-button-danger" label="Slet Bruger" icon="pi pi-trash" onClick={this.deleteAccount} />
						</div>
					</div>
				}
				</IonContent>
			</IonPage>
		)
	}
}

export default withRouter(withIonLifeCycle(Settings));
